import { render, staticRenderFns } from "./FavoritePage.vue?vue&type=template&id=6adc47d0&scoped=true&"
import script from "./FavoritePage.vue?vue&type=script&lang=js&"
export * from "./FavoritePage.vue?vue&type=script&lang=js&"
import style0 from "./FavoritePage.vue?vue&type=style&index=0&id=6adc47d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc47d0",
  null
  
)

export default component.exports